import { render } from "./TheSearchResultMain.vue?vue&type=template&id=e5d89190&scoped=true&ts=true"
import script from "./TheSearchResultMain.vue?vue&type=script&lang=ts"
export * from "./TheSearchResultMain.vue?vue&type=script&lang=ts"

import "./TheSearchResultMain.vue?vue&type=style&index=0&id=e5d89190&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5d89190"]])

export default __exports__